/* ALON · shopping components
 * 1. Product card / featured pack "הוספה לסל" (AJAX add for single-variant
 *    products; one fetch, tracked once by Shopify's own cart/add.js listener).
 *    An optional checked [data-alon-qty] radio inside the wrapper sets the
 *    quantity (featured pack: the multipack tiles, snippets/alon-bundle-options).
 * 2. Featured pack (sections/alon-featured-pack): the big price follows the
 *    chosen tile and the delivery note stays true for the real cart total;
 *    multipack tiles on the product page set the form's quantity field;
 *    smooth scroll for data-af-scroll links (hero button -> featured pack).
 * 3. Product page: keep the pack-selector links and the per-variant
 *    description in step with the real selected variant (pubsub
 *    "variant-change", published by assets/product-info.js).
 * Loaded with defer. No dependencies; uses the theme's add-to-cart
 * confirmation (window.__alonCartNotification, sections/alon-header.liquid) and pubsub
 * (assets/pubsub.js) when present, exactly like the theme's own product form.
 */
(function () {
  'use strict';

  /* Several sections include this file; run it once per page. */
  if (window.__alonShopLoaded) return;
  window.__alonShopLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* assets/constants.js declares PUB_SUB_EVENTS with a top-level const: it is
     a shared global binding, not a window property. */
  function pubSubEvents() {
    return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  }

  /* ---------- 1. Card add to cart ---------- */
  function onCardAdd(event) {
    var button = event.target.closest && event.target.closest('[data-alon-add-button]');
    if (!button) return;
    var wrap = button.closest('[data-alon-add]');
    if (!wrap || button.classList.contains('is-loading')) return;
    event.preventDefault();

    var status = wrap.querySelector('.ac-card__status');
    var variantId = wrap.getAttribute('data-variant-id');
    if (!variantId) return;
    var qtyInput = wrap.querySelector('[data-alon-qty]:checked');
    var quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    if (status) {
      status.textContent = '';
      status.classList.remove('is-error');
    }

    /* The sections the header's confirmation needs with the reply (the cart
       bubble and sections/alon-cart-confirm), the same list Dawn's product
       form requests. */
    var sections = 'cart-icon-bubble';
    try {
      var notification = window.__alonCartNotification;
      if (notification && typeof notification.getSectionsToRender === 'function') {
        sections = notification.getSectionsToRender().map(function (section) { return section.id; }).join(',');
      }
    } catch (sectionsError) {
      sections = 'cart-icon-bubble';
    }
    /* What the customer chose (a multipack tile's quantity included): the
       confirmation says how many packs were ADDED, which the reply cannot
       tell (it returns one of the lines a multipack is split into). */
    window.__alonAddRequest = { id: String(variantId), quantity: quantity, at: Date.now(), el: button, active: null, source: 'card' };

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(
          function (data) { return { ok: response.ok, data: data }; },
          function () { return { ok: false, data: {} }; }
        );
      })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.status) {
          var shopError = new Error(data.description || data.message || '');
          shopError.fromShop = true;
          throw shopError;
        }
        return data;
      })
      .then(
        function (data) {
          button.classList.add('is-added');
          if (status) {
            status.classList.add('visually-hidden');
            status.textContent = wrap.getAttribute('data-msg-added') || '';
          }
          window.setTimeout(function () {
            button.classList.remove('is-added');
            if (status) status.textContent = '';
          }, 2400);

          /* The item is in the cart: anything below is feedback only and must
             never turn a successful add into an error message. */
          try {
            document.dispatchEvent(new CustomEvent('alon:cart-added', { detail: { variantId: variantId, quantity: quantity } }));
          } catch (eventError) {
            /* ignore */
          }
          try {
            if (window.__alonCartNotification && typeof window.__alonCartNotification.renderContents === 'function') {
              window.__alonCartNotification.renderContents(data);
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
            var events = pubSubEvents();
            if (typeof window.publish === 'function' && events) {
              var published = window.publish(events.cartUpdate, { source: 'alon-card', productVariantId: variantId, cartData: data });
              if (published && typeof published.catch === 'function') published.catch(function () {});
            }
          } catch (feedbackError) {
            /* ignore */
          }
        },
        function (error) {
          if (!status) return;
          status.classList.remove('visually-hidden');
          status.classList.add('is-error');
          /* Shopify's own (localised) message when it sent one; otherwise ours —
             never a raw network/parser string. */
          status.textContent = (error && error.fromShop && error.message) || wrap.getAttribute('data-msg-error') || '';
        }
      )
      .then(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', onCardAdd);

  /* ---------- 2. Featured pack ---------- */
  function featuredRefresh(wrap) {
    var price = parseInt(wrap.getAttribute('data-af-price'), 10) || 0;
    var cartTotal = parseInt(wrap.getAttribute('data-af-cart'), 10) || 0;
    var freeFrom = parseInt(wrap.getAttribute('data-af-free-from'), 10) || 0;
    /* A discount in the cart: added packs might not add their full price, so
       no prediction (the cart's own status is still shown). */
    var discounted = wrap.getAttribute('data-af-discounted') === '1';
    var qtyInput = wrap.querySelector('[data-alon-qty]:checked');
    var quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    /* What the choice adds: a tile's offer total (charged through Shopify's
       automatic discount), otherwise quantity × price. */
    var addTotal = qtyInput && qtyInput.hasAttribute('data-total')
      ? (parseInt(qtyInput.getAttribute('data-total'), 10) || 0)
      : quantity * price;

    var panel = wrap.closest('[data-af-pack]');
    var totalEl = panel && panel.querySelector('[data-af-total]');
    var regularEl = panel && panel.querySelector('[data-af-regular]');
    if (totalEl && qtyInput && qtyInput.getAttribute('data-total-label')) {
      totalEl.textContent = qtyInput.getAttribute('data-total-label');
    }
    if (regularEl) {
      var regular = qtyInput ? (parseInt(qtyInput.getAttribute('data-regular'), 10) || 0) : 0;
      var showWas = regular > addTotal;
      regularEl.hidden = !showWas;
      regularEl.textContent = showWas ? (qtyInput.getAttribute('data-regular-label') || '') : '';
    }

    var ship = wrap.querySelector('[data-af-ship]');
    if (ship && freeFrom > 0) {
      /* Real status when the cart already qualifies; otherwise what adding
         the chosen tile would do; otherwise price + threshold. */
      var already = cartTotal > 0 && cartTotal >= freeFrom;
      var free = already || (!discounted && cartTotal + addTotal >= freeFrom);
      var msg = already ? wrap.getAttribute('data-af-msg-now') : (free ? wrap.getAttribute('data-af-msg-free') : wrap.getAttribute('data-af-msg-paid'));
      ship.textContent = msg || '';
      ship.classList.toggle('is-free', free);
    }

    var button = wrap.querySelector('[data-alon-add-button]');
    if (button) {
      var label = quantity === 1
        ? button.getAttribute('data-af-label-1')
        : (button.getAttribute('data-af-label-n') || '').replace('[n]', String(quantity));
      if (label) button.setAttribute('aria-label', label);
    }
  }

  /* Product page: the chosen multipack tile is the form's quantity. */
  function syncBundleQty(fieldset) {
    var hidden = fieldset && fieldset.querySelector('[data-alon-bundle-qty]');
    if (!hidden) return;
    var checked = fieldset.querySelector('[data-alon-qty]:checked');
    hidden.value = checked ? checked.value : '1';
  }

  function featuredWraps() {
    return document.querySelectorAll('[data-af-pack] [data-alon-add]');
  }

  function featuredSyncCart() {
    if (!featuredWraps().length) return;
    /* The header's shared reader (one request with the cart toast). */
    var request = typeof window.__alonFetchCart === 'function'
      ? window.__alonFetchCart()
      : fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; });
    request
      .then(function (cart) {
        if (!cart || typeof cart.total_price !== 'number') return;
        featuredWraps().forEach(function (wrap) {
          wrap.setAttribute('data-af-cart', String(cart.total_price));
          wrap.setAttribute('data-af-discounted', (cart.total_discount > 0 || cart.total_price < cart.items_subtotal_price) ? '1' : '0');
          featuredRefresh(wrap);
        });
      })
      .catch(function () { /* keep the server-rendered note */ });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-alon-qty]');
    if (!input) return;
    syncBundleQty(input.closest('[data-alon-bundles]'));
    var wrap = input.closest('[data-alon-add]');
    if (wrap) featuredRefresh(wrap);
  });
  document.addEventListener('alon:cart-added', featuredSyncCart);
  /* A restored page (back/forward, or a browser that keeps radio state) may
     show another quantity than the server-rendered note assumed. */
  function featuredRefreshAll() {
    document.querySelectorAll('[data-alon-bundles]').forEach(syncBundleQty);
    featuredWraps().forEach(featuredRefresh);
  }
  window.addEventListener('pageshow', function (event) {
    featuredRefreshAll();
    if (event.persisted) featuredSyncCart();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', featuredRefreshAll);
  else featuredRefreshAll();

  /* data-af-scroll links (the hero button): smooth scroll to that section
     when it is on this page, otherwise follow data-af-fallback. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-af-scroll]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('data-af-scroll'));
    if (!target) {
      /* e.g. the hero button when its section is not on the page */
      var fallback = link.getAttribute('data-af-fallback');
      if (fallback) {
        event.preventDefault();
        window.location.href = fallback;
      }
      return;
    }
    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var heading = target.querySelector('h2');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  });

  /* ---------- 3. Product page: follow the selected variant ---------- */
  function parsePairs(value) {
    var map = {};
    (value || '').split(';').forEach(function (pair) {
      var at = pair.lastIndexOf('=');
      if (at > 0) map[pair.slice(0, at)] = pair.slice(at + 1);
    });
    return map;
  }

  function followVariant(variant) {
    if (!variant || !variant.id) return;

    /* Pack tiles: same length on another pack only when that pack has it. */
    document.querySelectorAll('[data-alon-pack-link]').forEach(function (link) {
      var base = link.getAttribute('data-url');
      if (!base) return;
      var match = parsePairs(link.getAttribute('data-variants'))[variant.option1];
      link.setAttribute('href', match ? base + '?variant=' + match : base);
    });

    /* Per-variant content (e.g. the description accordion). */
    document.querySelectorAll('[data-alon-variant-scope]').forEach(function (scope) {
      var items = scope.querySelectorAll('[data-alon-variant-item]');
      var matched = false;
      items.forEach(function (item) {
        var isMatch = item.getAttribute('data-alon-variant-item') === String(variant.id);
        item.hidden = !isMatch;
        if (isMatch) matched = true;
      });
      if (!matched && items.length) items[0].hidden = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var events = pubSubEvents();
    if (typeof window.subscribe !== 'function' || !events) return;
    window.subscribe(events.variantChange, function (event) {
      followVariant(event && event.data && event.data.variant);
    });
    /* Adds made by the theme's own product forms on the same page. */
    window.subscribe(events.cartUpdate, function (event) {
      if (event && event.source === 'alon-card') return;
      featuredSyncCart();
    });
  });
})();
